var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductPacking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 203 203",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_726583616"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M64 143l-29 0c-2,0 -4,2 -4,4l0 25c0,2 2,4 4,4l29 0c3,0 4,-2 4,-4l0 -25c0,-2 -1,-4 -4,-4zm-4 25l-21 0 0 -17 21 0 0 17z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    x: 75,
    y: 149,
    width: 18.6597,
    height: 8.29066
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    x: 75,
    y: 162,
    width: 47.6882,
    height: 8.29066
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    x: 155,
    y: 166,
    width: 16.587,
    height: 8.29066
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    x: 155,
    y: 153,
    width: 16.587,
    height: 8.29066
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M203 106l-15 -39c0,-2 -2,-3 -3,-3l-25 0 0 -49c0,-3 -2,-5 -4,-5l-108 0c-3,0 -4,2 -4,5l0 49 -25 0c-2,0 -4,1 -4,3l-15 37c0,2 0,3 1,4 0,1 2,2 3,2l11 0 0 79c0,2 1,4 4,4l166 0c2,0 4,-2 4,-4l0 -77 10 0c1,0 3,-1 3,-2 1,-1 1,-2 1,-4zm-151 -87l66 0 0 12 -66 0 0 -12zm0 20l66 0 0 25 -66 0 0 -25zm-42 63l11 -29 116 0 -11 29 -116 0zm129 83l-116 0 0 -75 106 0c1,0 3,-1 3,-3l7 -16 0 94zm-13 -121l0 -45 25 0 0 45 -8 0 -17 0zm54 121l-33 0 0 -98 11 23c1,1 2,2 4,2l18 0 0 73zm-16 -81l-14 -31 32 0 11 31 -29 0z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    x: 133,
    y: 27,
    width: 12.4361,
    height: 8.29066
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    x: 133,
    y: 39,
    width: 12.4361,
    height: 8.29066
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductPacking);
export default __webpack_public_path__ + "static/media/ProductPacking.a2b068497180682572ba37fc70b545d7.svg";
export { ForwardRef as ReactComponent };